import { render, staticRenderFns } from "./TwentyBig.vue?vue&type=template&id=ae51e9ee&scoped=true&"
import script from "./TwentyBig.vue?vue&type=script&lang=js&"
export * from "./TwentyBig.vue?vue&type=script&lang=js&"
import style0 from "./TwentyBig.vue?vue&type=style&index=0&id=ae51e9ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae51e9ee",
  null
  
)

export default component.exports